import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from './store/store';
import esriLogger from '@arcgis/core/core/Logger';
import { logSessionHeader } from '@origo/logger';
import './index.css';
import '../../packages/origo-ui/index.css';
import '../../packages/origo-ui/dist/style.css';
import '@origo/origo-components/dist/style.css';

esriLogger.getLogger('esri').level = import.meta.env.PROD ? 'error' : 'warn';

logSessionHeader({
    app: 'planforvaltning',
    version: __APP_VERSION__,
    commit: __APP_COMMIT__,
    customer: 'dev',
    buildDate: __APP_BUILD_DATE__,
});

import { createI18n } from '@origo/i18n';
import appNb from './translations/nb.json';
import appEn from './translations/en.json';

export const i18n = createI18n({
    defaultLanguage: 'nb',
    resources: [
        { nb: { translation: appNb }, en: { translation: appEn } }
    ]
});

import '@esri/calcite-components/dist/components/calcite-tooltip';
import '@arcgis/core/assets/esri/themes/light/main.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>
);
